'use client';

import { useEffect } from 'react';

// Suppresses known third-party console errors that are noisy and unactionable.
export default function SuppressConsoleErrors() {
  useEffect(() => {
    const original = console.error;
    console.error = (...args: Parameters<typeof console.error>) => {
      if (typeof args[0] === 'string' && args[0].includes('[GSI_LOGGER]')) return;
      original.apply(console, args);
    };
    return () => {
      console.error = original;
    };
  }, []);

  return null;
}
